// extracted by css-extract-rspack-plugin
export default {"AdHocLeftSideRoot":"AdHocQuestionLeftSide-module__AdHocLeftSideRoot___ymK_u"};